import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faComments,
  faClipboardList,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import "./NewStudyModal.scss";

const NewStudyModal = ({ isOpen, onClose, projectSlug }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleConversationClick = () => {
    onClose();
    if (projectSlug) {
      navigate(`/project/${projectSlug}/conversation-study-maker`);
    } else {
      navigate("/conversation-study-maker");
    }
  };

  const handleFormClick = () => {
    onClose();
    if (projectSlug) {
      navigate(`/project/${projectSlug}/study/new`);
    } else {
      navigate("/study/new");
    }
  };

  return (
    <div className="new-study-modal-overlay">
      <div className="new-study-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="new-study-modal-header">
          <h2>새 리서치 생성</h2>
          <button className="new-study-modal-close-btn" onClick={onClose} title="닫기">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="new-study-modal-body">
          <div className="new-study-cards-grid">
            {/* 왼쪽 카드: AI 동료 리서처와 대화하며 생성하기 */}
            <button
              type="button"
              className="new-study-card"
              onClick={handleConversationClick}
            >
              <div className="new-study-card-badge new-study-card-badge-purple">
                <FontAwesomeIcon icon={faComments} />
                <span>대화형 생성 방식</span>
              </div>
              <h3>AI 동료 리서처와 대화하며 생성하기</h3>
              <p>
                리서치 배경과 고민을 대화로 설명하면
                <br />
                AI 동료 리서처가 단계별로 함께 설계해드립니다.
              </p>
            </button>

            {/* 오른쪽 카드: 입력폼을 통해 빠르게 생성하기 */}
            <button
              type="button"
              className="new-study-card"
              onClick={handleFormClick}
            >
              <div className="new-study-card-badge new-study-card-badge-green">
                <FontAwesomeIcon icon={faClipboardList} />
                <span>폼 기반 생성 방식</span>
              </div>
              <h3>입력폼을 통해 빠르게 생성하기</h3>
              <p>
                연구 이름과 목적, 알고 싶은 내용을 간단히 입력하면
                <br />
                손 쉽게 바로 리서치를 생성할 수 있습니다.
              </p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewStudyModal;
